import { Component, OnInit } from '@angular/core';
import { ListingCardComponent } from '../../listing-card/listing-card.component';
import { IListing, IListingsResponse, ListingsService } from '@out-web/core';
import { CommonModule } from '@angular/common';
import { RouterLink } from '@angular/router';
import { ListingSkeletonComponent } from '../../../molecules/listing-skeleton/listing-skeleton.component';

@Component({
  selector: 'out-home-listings',
  imports: [
    ListingCardComponent,
    CommonModule,
    RouterLink,
    ListingSkeletonComponent,
  ],
  templateUrl: './home-listings.component.html',
  styleUrl: './home-listings.component.scss',
})
export class HomeListingsComponent implements OnInit {
  placeholders = Array(9).fill(0);
  placeholderSkeletons = Array(9).fill(0);

  listings: IListing[] = [];
  isLoading = false;
  noListingsMessage = '';

  constructor(private listingsService: ListingsService) {}
  ngOnInit() {
    this.loadListings();
  }

  loadListings() {
    this.isLoading = true;
    this.listingsService
      .fetchListings({ listingType: '!Sold' }, 'featured')
      .subscribe({
        next: (data: IListingsResponse) => {
          this.listings = data.listings;
          this.isLoading = false;

          // Check if listings are empty
          if (this.listings.length === 0) {
            this.noListingsMessage = 'There are currently no listings.';
          } else {
            this.noListingsMessage = ''; // Clear the message if listings are available
          }
        },
        error: (error) => {
          console.error('Error fetching listings', error);
          this.isLoading = false;
        },
        complete: () => {
          // You can add a callback here if needed
        },
      });
  }
}
